import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';
import { useAppSelector } from '@/shared/hooks';

import { organizationModel } from '@/entities/organization';
import { reportsModel } from '@/entities/reports';

export const useFDA3DGPRestrictions = () => {
  const { isFDA3DGPRestrictions, manualPercentInput } = useAppSelector(
    organizationModel.selectors.selectFDAEnvironment,
  );

  const isSettingsLoaded = useAppSelector(
    organizationModel.selectors.selectRelevantOrganizationSettingsLoaded,
  );

  const currentReportType = useAppSelector(
    reportsModel.selectors.selectCurrentReportType,
  );

  const currentReportSignStatus = useAppSelector(
    reportsModel.selectors.selectCurrentReportSignStatus,
  );

  const isGPReport = currentReportType === ReportType.ReportType_CBCT_GP;
  const isReportSigned = currentReportSignStatus === 'signed';

  const isRestrictionContextReady =
    isSettingsLoaded && currentReportType !== undefined;

  return {
    isFDA3DGPRestrictions,
    shouldEnforceMinimumAge: isFDA3DGPRestrictions,
    shouldHideSuspiciousTeethToggle:
      !isRestrictionContextReady || (isFDA3DGPRestrictions && isGPReport),
    shouldHideConditionDetailsToggle:
      !isRestrictionContextReady || (isFDA3DGPRestrictions && isGPReport),
    shouldHideProbabilities: isFDA3DGPRestrictions && isGPReport,
    shouldApplyToothChartRestrictions: isFDA3DGPRestrictions && isGPReport,
    shouldHideOtherFindings:
      (isFDA3DGPRestrictions && isGPReport) || manualPercentInput,
    shouldHideProbabilityTab:
      manualPercentInput || (isFDA3DGPRestrictions && isGPReport),
    shouldFilterToothCardConditions: isFDA3DGPRestrictions && isGPReport,
    shouldRestrictPrint: isFDA3DGPRestrictions && isGPReport && !isReportSigned,
    shouldHidePeriapicalVolume: isFDA3DGPRestrictions && isGPReport,
  };
};
